(function (scope) {
  'use strict';
  function estimate(items) {
    var prices = items.map(function (item) { return Number(item.price); });
    if (prices.some(function (price) { return !Number.isSafeInteger(price) || price < 0; })) throw new TypeError('Invalid price');
    prices.sort(function (a, b) { return a - b; });
    var discounted = Math.floor(prices.length / 2);
    var subtotal = prices.reduce(function (sum, price) { return sum + price; }, 0);
    var savings = prices.slice(0, discounted).reduce(function (sum, price) { return sum + Math.round(price * 0.4); }, 0);
    return { subtotal: subtotal, savings: savings, total: subtotal - savings, discounted: discounted };
  }
  function aggregate(items) {
    var counts = new Map();
    items.forEach(function (item) {
      var id = String(item.variantId);
      if (!/^\d+$/.test(id)) throw new TypeError('Invalid variant');
      counts.set(id, (counts.get(id) || 0) + 1);
    });
    return Array.from(counts, function (entry) { return { id: Number(entry[0]), quantity: entry[1] }; });
  }
  scope.ACBlackFriday = { estimate: estimate, aggregate: aggregate };
  if (typeof module !== 'undefined' && module.exports) module.exports = scope.ACBlackFriday;
})(typeof window !== 'undefined' ? window : globalThis);
